import { Form } from "react-bootstrap";
import { SwitchContainer } from "./style";
import { ChangeEvent } from "react";

interface IProps {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  disabled?: boolean;
  title?: string;
  corProjeto?: boolean;
}

export function SwitchCustom({
  onChange,
  checked,
  disabled = false,
  title,
  corProjeto = false,
}: IProps) {
  return (
    <SwitchContainer $corProjeto={corProjeto}>
      <Form.Check type="switch" inline>
        <Form.Check.Input
          type="checkbox"
          onChange={onChange}
          checked={checked}
          disabled={disabled}
          title={title}
        />
      </Form.Check>
    </SwitchContainer>
  );
}
